import { Select } from 'antd';
import { Option } from 'antd/es/mentions';
import React from 'react'

export const FoodSectionCombo = ({ onChange }) => {
    // ======================================================================
    const handleChange = (value) => {
        if (onChange) onChange(value);
    };
    // ======================================================================
    return (
        <Select
        style={{width:'100%'}}
             onChange={handleChange}
            optionFilterProp="children"
            showSearch
            filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
            }
        >
                <Option  value={0}>
                    سحری
                </Option>
                <Option  value={1}>
                    صبحانه
                </Option>
                <Option  value={2}>
                    ناهار
                </Option>
                <Option  value={3}>
                    افطاری
                </Option>
                <Option  value={4}>
                    شام
                </Option>
        </Select>
    )
}
